<div class="condensed-full-header-wrapper">
  <div>
    <div class="detailview-image">
      <div
        class="image-border"
        miq-bg-image
        [secureImage]="
          reportRecordData
            | reportFieldFormatter
              : { templateId: currentView.templateId, field: imageField, joinString: true, onlyUrl: false }
            | async
        "
      ></div>
    </div>

    <div class="secondary-images">
      <div class="additional-image-block" *ngIf="!hasAdditionalImage; else additionalImageBlock">
        <div>
          <mat-icon svgIcon="add-icon"></mat-icon>
          <span (click)="addImage()" l10nTranslate>recordPPT.addImage</span>
        </div>
      </div>
      <ng-template #additionalImageBlock>
        <div class="image">
          <div class="actions">
            <mat-icon svgIcon="edit-icon" (click)="editImage(0)"></mat-icon>
            <mat-icon svgIcon="delete" (click)="deleteImage(0)"></mat-icon>
          </div>
          <div
            class="with-additional-image"
            miq-bg-image
            [secureImage]="
              reportRecordData
                | reportFieldFormatter
                  : {
                      templateId: currentView.templateId,
                      field: additionalImageField,
                      joinString: true,
                      onlyUrl: false,
                    }
                | async
            "
          ></div>
        </div>
      </ng-template>

      <div class="additional-image-block" *ngIf="!hasSecondaryImage; else secondaryImageBlock">
        <div>
          <mat-icon svgIcon="add-icon"></mat-icon>
          <span (click)="addImage()" l10nTranslate>recordPPT.addImage</span>
        </div>
      </div>
      <ng-template #secondaryImageBlock>
        <div class="image">
          <div class="actions">
            <mat-icon svgIcon="edit-icon" (click)="editImage(1)"></mat-icon>
            <mat-icon svgIcon="delete" (click)="deleteImage(1)"></mat-icon>
          </div>
          <div
            class="with-additional-image"
            miq-bg-image
            [secureImage]="
              reportRecordData
                | reportFieldFormatter
                  : {
                      templateId: currentView.templateId,
                      field: secondaryImageField,
                      joinString: true,
                      onlyUrl: false,
                    }
                | async
            "
          ></div>
        </div>
      </ng-template>
    </div>
    <div class="reset-images">
      <mat-icon svgIcon="refresh" aria-hidden="false"></mat-icon>
      <span (click)="resetImages()" l10nTranslate>recordPPT.resetImages</span>
    </div>
  </div>
</div>
